import { render, staticRenderFns } from "./InventoryMonitor.vue?vue&type=template&id=e251cffc&scoped=true"
import script from "./InventoryMonitor.vue?vue&type=script&lang=js"
export * from "./InventoryMonitor.vue?vue&type=script&lang=js"
import style0 from "./InventoryMonitor.vue?vue&type=style&index=0&id=e251cffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e251cffc",
  null
  
)

export default component.exports